<template>
    <div>
        <base-dialog :loading="loading" :value="dialog" :width="480" :title="`${$t('common.edit')} ${$t('common.subgroup').toLowerCase()}s`"
            @input="onInput" @close="hide">
            <div class="subgroup-add-row">
                <span class="subgroup-add-label">{{ $t('common.add') }} {{ $t('common.subgroup').toLowerCase() }}</span>
                <button type="button" class="subgroup-add-btn" @click="addSubgroup">
                    <v-icon size="16">mdi-plus</v-icon>
                </button>
            </div>

            <div class="subgroup-list">
                <kimsa-text-field v-for="(group, i) in groups" :key="group.id"
                    :placeholder="`${$t('common.subgroup')} ${i + 1}`" @change="groups[i].name = $event"
                    :value="groups[i].name" force-value dense :icon="canRemove(i) ? 'mdi-close' : ''"
                    @click:append="removeSubgroup(i)" />
            </div>

            <template #footer>
                <dialog-actions :confirm-label="$t('common.save')" :disabled="!valid" :loading="loading"
                    @cancel="hide" @confirm="save" />
            </template>
        </base-dialog>
    </div>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import { db } from "@/utils/Firebase";
import { removeStudentsFromGroup } from "@/utils/Exercises";
import BaseDialog from '@/components/common/BaseDialog';
import DialogActions from '@/components/common/DialogActions';

export default {
    name: "CreateGroupEvaluationDialog",
    components: { KimsaTextField, BaseDialog, DialogActions },
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            groups: [{ id: 0, name: '', students: [] }],
            team: null,
            editMode: false,
            groupsDeleted: [],
        }
    },
    computed: {
        valid(vm = this) {
            return !vm.groups.find(group => !group.name)
        }
    },
    methods: {
        show(team) {
            const vm = this
            vm.dialog = true
            vm.setDefaults(team)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        onInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.name = ''
            vm.groups = [{ id: 0, name: '', students: [] }]
            vm.team = null
            vm.editMode = false
            vm.groupsDeleted = []
        },
        setDefaults(team) {
            const vm = this
            vm.groups = [...team?.evaluationGroups || [{ id: 0, name: '', students: [] }]]
            vm.team = team
        },
        canRemove(index) {
            return this.groups.length > 1 || index !== 0
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                if (vm.groupsDeleted.length > 0) {
                    for (let group of vm.groupsDeleted) {
                        await removeStudentsFromGroup(group.students || [])
                    }
                }

                await db.collection('teams').doc(vm.team.id).update({
                    evaluationGroups: vm.groups,
                })
                vm.toast(vm.$t('common.team_edited'))

                vm.hide()
            })
        },
        addSubgroup() {
            const vm = this
            let groupId = vm.groups[vm.groups.length - 1].id + 1
            vm.groups.push({ id: groupId, name: '', students: [] })
        },
        removeSubgroup(index) {
            const vm = this
            vm.groupsDeleted.push(vm.groups[index])
            vm.groups.splice(index, 1)
        }
    },
}
</script>

<style scoped>
.subgroup-add-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding-bottom: 12px;
    margin-bottom: 14px;
    border-bottom: 1px solid var(--v-outline-base);
}

.subgroup-add-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    text-transform: capitalize;
}

.subgroup-add-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    border: 1px solid var(--v-outline2-base);
    background: none;
    color: var(--v-primary-base);
    cursor: pointer;
    transition: background 0.15s;
}

.subgroup-add-btn:hover {
    background: rgba(204, 255, 51, 0.1);
}

.theme--light .subgroup-add-btn {
    color: var(--v-accent-base);
}

.theme--light .subgroup-add-btn:hover {
    background: rgba(51, 153, 153, 0.1);
}

.subgroup-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
</style>
